import ArticleLayout from '@/components/base/ArticleLayout';
import { allArticles } from '@/mocks/seoArticles';

export default function RisparmioItaobuyPage() {
  return <ArticleLayout data={allArticles['risparmio-itaobuy']} />;
}